// extracted by mini-css-extract-plugin
export default {"drawer":"fY","drawerheader":"gY","retake_quiz_bottom_bar":"hY","extra_drawer":"iY","not_answered_questions":"jY","question_ui":"kY","accordion_details":"lY","retake_quiz":"mY","accordions":"nY","accordion_root":"oY","accordion_summary_text":"pY","animation":"qY","show_animation":"rY","overflow_hidden":"sY"};
    if(module.hot) {
      // 1737143663917
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  